import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import Debounce from '../../js/lib/debounce';


const docList = document.getElementsByClassName('docList');

for (var x = 0; x < docList.length; x++) {

    const linkItem = docList[x];
    const id = linkItem.id;
    const groupId = id.split('_')[1];
    const pageId = linkItem.getAttribute('pageId');
	const loaderUrl = linkItem.getAttribute('data-loader');
	const fileUrl = linkItem.getAttribute('data-fileloader');
    const initUrl = envVar({
        backendPath: loaderUrl + '/?catID=' + groupId + '&pageID=' + pageId
    });

    const docListVue = new Vue({
        // countries Element ~> this.$el
        el: '#' + id,
        // Define Schema ~> set to null/0
        data: {
            groupId: '',
            pageId: '',
            documents: '',
            loaded: false,
        },
        // When Component is Mounted, run Methods
        mounted: function () {
            const self = this;
            self.groupId = groupId;
            self.pageId = pageId;
        },
        methods: {
            loadDocuments: function () {
                const self = this;

				if(!self.loaded)
                {
					// have to add a random number here to make sure IE will always refresh; it is caching the results if not
					request().get(initUrl + "&randNum=" + Math.floor(Math.random() * 10000)).then(function (response) {
						self.documents = response;
						self.loaded = true;
					});
                }
				else
					self.loaded = false;
            },
            getDocHref: function (docNumber, docFileName) {
                var url = fileUrl + "?docId=" + docNumber + "&docFileName=" + docFileName;
                return encodeURI(url);
            },
        }
    });
}


   



// WEBPACK FOOTER //
// ../components/documentlist/documentlist.js